import { PrismicImage, PrismicLink } from "@prismicio/react";
import type { ImageField, LinkField} from "@commercekit/prismic";
import type { FC } from "react";

const FooterGeneral: FC<{
  footerLogo: ImageField;
  logoLink: LinkField;
}> = ({
  footerLogo,
  logoLink,
}) => {
  return (
    <div className="footer">
      <div className="footer__menu-wrapper pb-4 pt-3 pt-lg-4 pt-xxl-5">
        <div className="container">
          <div className="row">
            <div className="footer__logo col-12 order-lg-2">
              <PrismicLink
                field={logoLink}
                className="d-block mt-3 pt-3 mb-0 mt-xxl-0 text-center"
              >
                <PrismicImage
                  alt=""
                  field={footerLogo}
                  loading="lazy"
                  width="203"
                  height="41"
                />
              </PrismicLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterGeneral;
